<template>
  <v-card
    outlined
    class="bulk-upload-card"
    :class="{ uploaded: !!existingFile, 'is-disabled': disabled }"
  >
    <v-card-title class="d-flex align-center justify-space-between py-3">
      <span class="text-subtitle-1 font-weight-medium">{{ bank }}</span>
      <v-icon
        v-if="existingFile"
        color="success"
      >
        mdi-check-circle
      </v-icon>
    </v-card-title>

    <v-divider />

    <v-card-text class="text-center py-6">
      <template v-if="existingFile">
        <div class="text-body-2 font-weight-medium">
          {{ existingFile.filename }}
        </div>
        <div
          v-if="existingFile.row_count != null"
          class="text-caption grey--text"
        >
          {{ existingFile.row_count }} rows
        </div>
        <v-btn
          v-if="!disabled"
          text
          small
          color="primary"
          class="mt-3"
          @click="openFilePicker"
        >
          <v-icon
            left
            small
          >
            mdi-refresh
          </v-icon>
          Replace
        </v-btn>
      </template>
      <template v-else>
        <v-icon
          large
          color="grey lighten-1"
        >
          mdi-cloud-upload-outline
        </v-icon>
        <div class="text-caption grey--text mt-2">
          {{ acceptedHint }}
        </div>
        <v-btn
          color="primary"
          outlined
          class="mt-3"
          :disabled="disabled"
          @click="openFilePicker"
        >
          Choose file
        </v-btn>
      </template>

      <input
        ref="fileInput"
        type="file"
        :accept="accept"
        class="d-none"
        @change="onFileChange"
      >
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'BulkUploadCard',
  props: {
    bank: {
      type: String,
      required: true,
    },
    accept: {
      type: String,
      required: true,
    },
    existingFile: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    acceptedHint() {
      const exts = this.accept
        .split(',')
        .map((s) => s.trim().replace(/^\./, '').replace(/^application\//, ''))
        .filter(Boolean);
      return `Accepts ${exts.join(', ')}`;
    },
  },
  methods: {
    openFilePicker() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const file = event.target.files?.[0];
      event.target.value = '';
      if (!file) return;
      if (!this.fileMatchesAccept(file)) {
        this.$store.commit('Toast_State', {
          value: true,
          color: 'error',
          msg: `Unsupported file type for ${this.bank}. Accepts ${this.accept}.`,
        });
        return;
      }
      this.$emit('upload', file);
    },
    fileMatchesAccept(file) {
      if (!this.accept) return true;
      const lcName = file.name.toLowerCase();
      const tokens = this.accept.split(',').map((s) => s.trim().toLowerCase());
      return tokens.some((t) => {
        if (t.startsWith('.')) return lcName.endsWith(t);
        return file.type === t;
      });
    },
  },
};
</script>

<style scoped>
.bulk-upload-card.uploaded {
  border-color: var(--v-success-base, #43a047) !important;
  border-width: 2px !important;
}
.bulk-upload-card.is-disabled {
  opacity: 0.6;
}
</style>
